import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import defaultAttrs from '../../../lib/utils/defaultAttrs';

const Container = styled.div`
  margin-left: 0;
  padding: 11px 10px;
  text-align: center;
  display: inline-block;
  height: auto;

  ${({ isActive }) =>
    isActive &&
    css`
      border-bottom: solid 2px ${themeGet('colors.primary.100')};
      color: ${themeGet('colors.primary.100')};
    `}
`;

const Arrow = styled.i.attrs(
  defaultAttrs({
    className: 'fa-regular fa-chevron-right fa-xs',
  }),
)`
  width: 6px;
  height: 12px;
  margin: 0px 20px;
`;

const Title = styled.span`
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.1px;
`;

const TabList = styled.li`
  display: flex;
  align-items: baseline;
`;

export const Tab = ({ title, statuses, activeStatus }) => {
  return (
    <TabList id={title}>
      <Container isActive={statuses.includes(activeStatus)}>
        <Title>{title}</Title>
      </Container>
      <Arrow />
    </TabList>
  );
};
